function EmptyRow() {
  return (
    <div className="text-center col-span-full">
      <span>Nothing to show</span>
    </div>
  );
}
export default EmptyRow;
